import type { ModalComponentProps } from '@/features/rundown/modals/modal.store'
import type { ShortcutCategory } from './rundown-shortcuts'

import { RUNDOWN_SHORTCUTS } from './rundown-shortcuts'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { KbdGrouper } from '@/components/ui/kbd'

export function ShortcutsModal({
  onResolve,
}: ModalComponentProps<'SHORTCUTS'>) {
  return (
    <Dialog
      open={true}
      onOpenChange={() => {
        onResolve()
      }}
    >
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Shortcuts</DialogTitle>
          <DialogDescription>
            Navigate your rundown more efficiently with these commands.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 -mx-4 pt-2 no-scrollbar max-h-[80vh] overflow-y-auto px-4">
          {RUNDOWN_SHORTCUTS.map((group: ShortcutCategory) => (
            <div key={group.title} className="flex flex-col gap-1">
              <h3 className="text-xs font-semibold uppercase tracking-wider opacity-50">
                {group.title}
              </h3>

              <ul className="flex flex-col gap-0.5">
                {group.items.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-center justify-between gap-4 text-sm py-2 border-b border-border/30 last:border-0"
                  >
                    <span>{item.description}</span>

                    <div className="flex flex-col items-center gap-1.5 shrink-0">
                      <KbdGrouper keys={item.keys} />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
